import consulting from "../../../api/consulting.json";
import { ListOfEvents } from "../../ListOfEvents/ListOfEvents";

export const Consulting = () => {
	const consultingData = consulting.map((consult) => ({
		id: consult.consultingId,
		year: consult.consultingYear,
		info: consult.consultingInfo,
		infoSecond: consult.consultingInfoSecond,
		infoThird: consult.consultingInfoThird,
		infoFourth: consult.consultingInfoFourth,
	}));
	return (
		<section className="container">
			<ListOfEvents events={consultingData} />
		</section>
	);
};
